import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageLayout } from '../../components';
import Login from './Login';
import Dashboard from './Dashboard';
import ResetPassword from './ResetPassword';
import { gql } from '../../utils/graphql';

const Ambassador = () => {
	const [ambassador, setAmbassador] = useState<any>(null);
	const [loading, setLoading] = useState(true);
	const { token: resetToken } = useParams<{ token?: string }>();
	const navigate = useNavigate();

	useEffect(() => {
		if (!resetToken) {
			loadAmbassadorData();
		} else {
			setLoading(false);
		}
	}, [resetToken]);

	const loadAmbassadorData = async () => {
		try {
			const query = `
        query GetMyProfile {
          ambassador {
            id
            firstName
            lastName
            email
            telephone
            events {
              id
              name
              city
              date
              inviteId
            }
            instagram
            tiktok
            points
            spentPoints
            soldTickets
            discountCodes {
              code
              discountId
              event {
                id
                name
              }
            }
            profileImage
            redeemedPrizes {
              name
              cost
              date
              isValidated
            }
          }
        }
      `;

			const response = await gql(query);

			if (response.data?.data?.ambassador) {
				setAmbassador(response.data.data.ambassador);
			} else {
				setAmbassador(null);
			}
		} catch (error) {
			console.error('Failed to load ambassador data', error);
			setAmbassador(null);
		} finally {
			setLoading(false);
		}
	};

	const logout = async () => {
		try {
			const mutation = `
				mutation Logout {
					logout
				}
			`;
			await gql(mutation);
		} catch (error) {
			console.error('Logout failed', error);
		}
		setAmbassador(null);
		window.location.reload();
	};

	const handleLoginSuccess = (_token: string, ambassadorData: any) => {
		setAmbassador(ambassadorData);
		loadAmbassadorData();
	};

	const handleBackToLogin = () => {
		navigate('/ambassador');
	};

	if (loading) {
		return (
			<PageLayout showFooter={false}>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', color: 'white' }}>
					Se încarcă...
				</div>
			</PageLayout>
		);
	}

	// Show reset password page if token is in URL
	if (resetToken) {
		return (
			<PageLayout showFooter={false}>
				<ResetPassword token={resetToken} onBackToLogin={handleBackToLogin} />
			</PageLayout>
		);
	}

	return (
		<PageLayout showFooter={false}>
			{!ambassador ? (
				<Login onLoginSuccess={handleLoginSuccess} />
			) : (
				<Dashboard
					ambassador={ambassador}
					token={''}
					onLogout={logout}
					refreshData={loadAmbassadorData}
				/>
			)}
		</PageLayout>
	);
};

export default Ambassador;
